<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <UserForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserForm from '@/components/organisms/master/form/UserForm'

export default {
  name: 'UserPage',
  components: {
    UserForm,
  },
}
</script>
